import { useChat } from "@ai-sdk/react";
import { DefaultChatTransport } from "ai";
import { useRef, useMemo, useCallback } from "react";
import { getHeadersWithUniqueVisitorId } from "../../Auth/index.js";
function generateConversationId() {
  const chars = "abcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";
  for (let i = 0; i < 10; i++) {
    result += chars[Math.floor(Math.random() * chars.length)];
  }
  return result;
}
function useConciergeChat(options) {
  const { apiBaseUrl, conversationId, appConfigId, devOptions, pdpStacklineSku, onError, onConversationIdGenerated } = options;
  const conversationIdRef = useRef(conversationId);
  conversationIdRef.current = conversationId;
  const transport = useMemo(
    () => new DefaultChatTransport({
      api: `${apiBaseUrl}/concierge/agent/stream`,
      headers: async () => ({
        ...await getHeadersWithUniqueVisitorId(),
        Accept: "text/event-stream"
      }),
      body: {
        get conversationId() {
          return conversationIdRef.current;
        },
        appConfigId,
        devOptions,
        ...pdpStacklineSku ? { pdpStacklineSku } : {}
      }
    }),
    [apiBaseUrl, appConfigId, devOptions, pdpStacklineSku]
  );
  const chat = useChat({
    transport,
    onError: (error) => {
      console.error("[useConciergeChat] Stream error:", (error == null ? void 0 : error.message) || error, error);
      onError == null ? void 0 : onError(error);
    },
    generateId: () => `msg-${Date.now()}-${Math.random().toString(36).substring(2, 9)}`
  });
  const sendMessage = useCallback(
    async (prompt, _imageData, _imageMimeType) => {
      if (!conversationIdRef.current) {
        const newId = generateConversationId();
        conversationIdRef.current = newId;
        onConversationIdGenerated == null ? void 0 : onConversationIdGenerated(newId);
      }
      await chat.sendMessage({ text: prompt });
    },
    [chat, onConversationIdGenerated]
  );
  const isStreaming = chat.status === "streaming";
  const isLoading = chat.status === "submitted";
  return {
    ...chat,
    sendMessage,
    isStreaming,
    isLoading,
    isWaiting: isLoading || isStreaming
  };
}
export {
  useConciergeChat
};
//# sourceMappingURL=useConciergeChat.js.map
